import { useCallback, useState } from 'react';

type AlertSeverity = 'success' | 'error' | 'warning' | 'info';

export const useAlert = () => {
  const [alert, setAlert] = useState<{
    open: boolean;
    severity: AlertSeverity;
    message: string;
  }>({
    open: false,
    severity: 'success',
    message: '',
  });

  const showAlert = useCallback((severity: AlertSeverity, message: string) => {
    setAlert({
      open: true,
      severity,
      message,
    });
  }, []);

  const handleCloseAlert = useCallback(() => {
    setAlert((prev) => ({ ...prev, open: false }));
  }, []);

  return {
    alert,
    showAlert,
    handleCloseAlert,
  };
};
